import { RumEvent } from '@datadog/browser-rum';

export const datadogRegex = /^https:\/\/((?!login\.)[a-zA-Z0-9-]+\.)?koddi\.io(\/|$)/;

export const initDatadogPayload = {
    applicationId: '8d231e00-e3cc-426c-a759-7be37b03036e',
    clientToken: 'pub84524eb84df97e8bdde91c3591ccf996',
    site: 'datadoghq.com',
    service: 'koddi-one',
    env: window.TARGET_ENV,
    version: window.UI_VERSION,
    sampleRate: 100,
    trackInteractions: true,
    trackFrustrations: true,
    trackUserInteractions: true,
    trackViewsManually: true,
    allowedTracingOrigins: [datadogRegex],
    enableExperimentalFeatures: ['feature_flags'],
    useCrossSiteSessionCookie: true,
    useSecureSessionCookie: true,
    beforeSend: (event: RumEvent): boolean | void => {
        const networkErrors =
            event.type === 'resource' &&
            [400, 401, 403].includes(event.resource?.status_code || 0);
        const cancelledRequests =
            event.type === 'error' &&
            event.error?.message.includes('Request was cancelled');
        const consoleError =
            /* @ts-ignore */
            event?.error?.source === 'console' &&
            /* @ts-ignore */
            event?.error?.handling === 'handled';
        const localhostErrors =
            window.location.hostname.includes('localhost') &&
            event.type === 'error';
        /* @ts-ignore */
        const chunkError = event.error?.message.includes('ChunkLoadError');
        if (
            networkErrors ||
            cancelledRequests ||
            consoleError ||
            localhostErrors ||
            chunkError
        ) {
            return false;
        }
        return true;
    },
};
